// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_LOGIN = "Prihl\u00e1senie";
